"use client";

import { useEffect, useState } from "react";

export const useIsSandbox = () => {
  const [isSandbox, setIsSandbox] = useState(false);
  useEffect(() => {
    if (window.location.host.includes("sandbox")) {
      setIsSandbox(true);
    }
  }, []);
  return isSandbox;
};
